import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Disabled: this is a landing/funnel served mostly to first-visit traffic, so
// offline caching gives little benefit but the service worker delayed new
// deploys reaching returning visitors (they kept running a stale bundle, which
// also kept them out of running experiments). unregister() tears down any SW a
// returning visitor still has so everyone gets fresh code on every visit.
serviceWorkerRegistration.unregister();
